//City-State tab
tabApp.controller('tabCSController', ['$scope', '$http', function($scope, $http) {

    $scope.tCS.getData = function() {

        $scope.global.hideTabError($scope.tCS);
        $scope.global.loadedDealers = [];

        var city = $scope.tCS.inputCity,
            state = $scope.tCS.inputState;

        //$scope.global.allDealers = [];
        $scope.global.filteredDealers = [];
        //$scope.global.filterDealers();
        $scope.global.locationLabel = (city || "") + ', ' + (state || "");

        if (!validateInput('cityStateInput') | !validateInput('state')) {
            if (!validateInput('cityStateInput')) {
                $('#cityStateInput').focus();
            }
            $scope.tCS.isError = true;
            return;
        } else {
            $scope.tCS.isError = false;
        }

        //get zip from city, state
        dl_getLatLonFromQuery(city + ', ' + state + ', United States', function(lat, lon) {

            dl_getPinCode(lat, lon, function(zip, lat, lon, address) {

                if ((address && address.countryRegion && address.countryRegion != "United States") || (zip || '').length != 5) {
                    $scope.global.showTabError($scope.tCS, 'No results found. Please try again');
                    return;
                }

                //load data
                $scope.global.locationLabel = zip;
                $scope.tZip.inputZip = zip;
                $scope.global.getData(zip, $scope.tCS);

                ZipStorage.setZip(zip);

                //tracking
                _satellite.track('dealerlocator_search_citystatesubmit');
            });
        });



    }

}]);